import { IAppState } from '../common/state';

export const selectIsCountrysideTrapEnabled = (state: IAppState): boolean => {
  return state.isCountrysideTrapEnabled;
};
